import Alpine from "alpinejs";
import { animate, scroll } from "motion";

Alpine.data('TimelineIntro', () => ({
    init(){
        this.updateAnimation();
    },

    updateAnimation(){
        const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        if(!prefersReducedMotion){
            this.$el.querySelectorAll(".animatedSection").forEach((section, index) => {
                const container = this.$el.querySelector('div');
                const content = section.querySelector(".content");
                const bubbles = section.querySelectorAll(".bubble");

                bubbles.forEach((bubble) => {

                    scroll(animate(bubble, { y: [-400, 400] }, { ease: "linear" }), {
                        target: container,
                        offset: ["start end", "end start"]
                    })
                })
                
                if(window.innerWidth < 768){
                    scroll(animate(content, { y: [0, 0] }, { ease: "linear" }), {
                        target: section,
                        offset: ["start end", "end start"]
                    });
                     
                } else {                    
                    scroll(animate(content, { y: [-100, 100] }, { ease: "linear" }), {
                        target: section,
                        offset: ["start end", "end start"]
                    });

                };

            })
        }
    },
    resizeEvent() {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.updateAnimation();
        }, 200) // debounce ms
    }
}));